/* DS: Normaliser delenummer-søk – fjerner mellomrom/punktum/bindestrek når søket kun består av siffer (f.eks. "0 445 110 321" -> "0445110321") */
window.dsNormalizeQuery = function (q) {
  if (typeof q !== 'string') return q;
  var t = q.trim();
  if (/^[0-9][0-9\s.\-]*$/.test(t) && /[\s.\-]/.test(t)) return t.replace(/[\s.\-]+/g, '');
  return q;
};
document.addEventListener(
  'submit',
  function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var a = f.getAttribute('action') || '';
    if (!/\/search\/?(\?|$)/.test(a)) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var n = window.dsNormalizeQuery(inp.value);
    if (n !== inp.value) inp.value = n;
  },
  true
);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
